<template>
  <v-app :style="cssVars">
    <template v-if="isLoggedIn">
      <vue-confirm-dialog></vue-confirm-dialog>
      <Navbar />
      <Progress />
      <Alert />
      <!-- Dashboard should not be cached as we need the latest updates -->
      <keep-alive exclude="Dashboard">
        <router-view />
      </keep-alive>
      <v-footer />
    </template>
    <template v-else>
      <v-content id="landing-page">
        <v-container fluid fill-height>
          <v-layout align-center justify-center>
            <Alert />
            <router-view />
          </v-layout>
        </v-container>
      </v-content>
    </template>
  </v-app>
</template>

<script>
import Navbar from './components/Navbar'
import Alert from './components/Alert'
import Progress from '@/components/Progress'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'App',
  components: { Navbar, Alert, Progress},
  computed: {
    ...mapGetters({
      isLoggedIn: 'User/getIsAuthenticated',
    }),
    cssVars() {
      return {
        'background-color': window.appConfig.backgroundColor,
      }
    }
  },
  mounted: function() {
    this.init()
    console.log(window.appConfig)
    document.title = window.appConfig.title
  },
  methods: {
    ...mapActions({
      init: 'User/init',
    }),
  },
}
</script>

<style>
#landing-page {
  background: rgb(255, 255, 255);
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 1) 0%,
    rgba(36, 132, 198, 1) 100%
  );
}

@media only screen and (max-width: 959px) {
  .container {
    padding: 0.2rem;
  }
}

</style>
